import React from 'react';
import PropTypes from 'prop-types';
import disableOnScrollToSite from 'core/components/ScrollToSite/disableOnScrollToSite';

import styles from './index.styl';

function LayoutFooter(props) {
  return (
    <div className={styles.footer} data-qa='lb-footer'>
      {props.children}
    </div>
  );
}

LayoutFooter.propTypes = {
  children: PropTypes.node,
};

export default disableOnScrollToSite(LayoutFooter);
